import gql from 'graphql-tag';

const getContractItemBalanceQuery = gql`
  query GetContractItemBalance(
    $organisationId: String!,
    $owners: [String]!,
    $types: [String]!
  ) {
    getContractItemBalance(
      organisationId: $organisationId,
      owners: $owners,
      types: $types
    ) {
      __typename
      ... on ProductBalance {
        product
        type
        value
      }
      ... on TeamBalance {
        teamId
        teamName
        type
        value
      }
    }
  }
`;

export default (() => ({
  query: getContractItemBalanceQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: (data) => {
    const {
      organisationId,
      owners,
      types
    } = data;
    return {
      organisationId,
      owners,
      types
    };
  }
}));